import { effectiveFeatureCatalogueSchema } from '@erp/shared';
import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api-client';

export const featureCatalogueQueryKey = ['features', 'effective'] as const;

export function useEffectiveFeatureCatalogue() {
  return useQuery({
    queryKey: featureCatalogueQueryKey,
    queryFn: () => apiFetch('/api/v1/features/effective', effectiveFeatureCatalogueSchema),
    staleTime: 10_000,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
  });
}
